import { useTranslation } from 'react-i18next'
import { Add } from '@mui/icons-material'
import { Box, Button, IconButton, Typography } from '@mui/material'

type SortFieldArrayButtonsGroupProps = {
  onAppend: () => void
  onClearAll: () => void
}

export const SortFieldArrayButtonsGroup = ({
  onAppend,
  onClearAll,
}: SortFieldArrayButtonsGroupProps) => {
  const { t } = useTranslation()

  return (
    <Box alignItems={'center'} display={'flex'}>
      <IconButton size={'small'} onClick={onAppend}>
        <Add fontSize='small' />
        <Typography variant='button'>
          {t('ganttCreate.common.addItem', { item: 'sort' })}
        </Typography>
      </IconButton>
      <Button onClick={onClearAll}>{t('ganttCreate.common.removeAll')}</Button>
    </Box>
  )
}
